<template>
    <scroll-page :titleArrs="titleArrs" :pageArrs="pageArrs" />
  </template>
  <script>
  export default {
    name: 'Purchase',
    data(){
      return{
        pageArrs: [ 'PurchaseTwo', 'PurchaseOne'],
        titleArrs: ['采办管理', '采办管理']
      }
    }
  }
  </script>